<template>
    <div class="row-detail-data">
        <div v-if="entity.start_date" class="user-data-item">
            <span class="icon material-symbols-outlined">calendar_month</span>
            <div>
                <span class="title">
                    Start date
                    <template v-if="entity.end_date">— End date</template>
                </span>
                <div class="user-input">
                    {{ formattedDateRange }}
                    <span v-if="durationDays">· {{ durationDays }} days</span>
                </div>
            </div>
        </div>
        <div v-if="countries.length" class="user-data-item">
            <span class="icon material-symbols-outlined">
                globe_location_pin
            </span>
            <div>
                <span class="title">Countries</span>
                <div class="user-input">{{ countries.join(", ") }}</div>
            </div>
        </div>
        <div v-if="entity.expenses" class="user-data-item">
            <span class="icon material-symbols-outlined">payments</span>
            <div>
                <span class="title">Total expenses</span>
                <div class="user-input">
                    {{ currency }}{{ entity.expenses }}
                </div>
            </div>
        </div>
        <div v-if="entity.expenses && entity.share < 1" class="user-data-item">
            <span class="icon material-symbols-outlined">payments</span>
            <div>
                <span class="title">Your expenses</span>
                <div class="user-input">{{ currency }}{{ userExpenses }}</div>
            </div>
        </div>
        <div v-if="companionNames.length" class="user-data-item">
            <span class="icon material-symbols-outlined">group</span>
            <div>
                <span class="title">With</span>
                <div class="user-input">{{ companionNames.join(", ") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { durationInDays, formatDateRange } from "js/lib/dates";

export default {
    name: "RowInfoTrip",
    props: {
        row: {
            type: Object,
            required: true,
        },
        entity: {
            type: Object,
            required: true,
        },
        currency: {
            type: String,
            default: "$",
        },
    },
    computed: {
        countries() {
            return this.row.derived?.countries ?? [];
        },
        durationDays() {
            return durationInDays(this.entity.start_date, this.entity.end_date);
        },
        formattedDateRange() {
            return formatDateRange(
                this.entity.start_date,
                this.entity.end_date
            );
        },
        companionNames() {
            return (this.entity.companions ?? []).map((c) => c.name);
        },
        userExpenses() {
            return Math.round(this.entity.share * this.entity.expenses);
        },
    },
};
</script>
